export default {
    sidebar: {
        active: false
    },
    usuario: {
        menu: [],
        nombre: '',
        usuarioId: 0,
        jerarquiaId: 0
    },
    toastService: {
        message: '',
        active: false
    }
}